<div
	class="skeleton-container"
	[ngClass]="animated ? 'animate' : 'static'"
	[ngStyle]="customStyle"
></div>
